<style scoped lang="sass">
.page
  background-color: white !important
  .pools
    padding: var(--base-padding)
    &.past-pools
      .pool
        background-color: var(--medium-gray)
    .section-heading
      display: flex
      margin-bottom: 0.5rem
    .pool
      display:          block
      border-radius:    0.5rem
      padding:          var(--base-padding)
      border-radius:    var(--base-border-radius)
      background-color: var(--blue)
      margin-bottom:    0.5rem
      color:            white
      .info-line
        display: flex
        align-items: center
        margin-top: 0.5rem
        .avatar
          width: 25px
          height: 25px
          border-radius: 13px
          margin-right: 1rem
        .participation-position
          font-size: 1.6rem
          font-weight: 700
        .participation-position-ordinal
          font-size: 0.8rem
          font-weight: 600
          margin-right: 1rem
        .participation-points
          font-size: 1.6rem
          font-weight: 300
        .participation-points-units
          font-size: 0.8rem
          font-weight: 600
          margin-right: 1rem
</style>
<template>
  <div class="page">
    <div v-if="pools.length" class="pools past-pools">
      <div class="section-heading font-style-2">Pool Archives</div>
      <transition-group name="fade-quickly">
        <router-link v-for="pool in pools" class="pool" :to="{name: 'pool', params: {id: pool.id}}" :key="pool.id">
          <div class="pool-name font-style-1">{{pool.name}}</div>
          <div v-if="pool.participation.position" class="info-line">
            <img :src="pool.participation.user.avatar_url" class="avatar">
            <div>
              <span class="participation-position">{{pool.participation.tie ? 'T' : null}}{{pool.participation.position}}</span><!--
              --><span class="participation-position-ordinal">{{indicator(pool.participation.position)}}</span>
            </div>
            <div>
              <span class="participation-points">{{pool.participation.points}}</span><!--
              --><span class="participation-points-units">PTS</span>
            </div>
          </div>
        </router-link>
      </transition-group>
      <a href="#" @click.prevent="loadNextPage" v-if="morePools" class="button positive">More...</a>
    </div>
  </div>
</template>
<script>
import api       from '../api';
import indicator from 'ordinal/indicator';

export default {
  name: 'PoolArchives',
  created() {
    this.$store.dispatch('configNavigation', {leftEnabled: true, leftRoute: {name: 'dashboard'}, leftImg: 'icon-back.svg'});
    this.loadNextPage();
  },
  computed: {
    pools() {
      return this.$store.getters['poolArchives/pools'];
    },
    morePools() {
      return this.$store.getters['poolArchives/morePools'];
    }
  },
  methods: {
    loadNextPage() {
      this.$store.dispatch('poolArchives/loadNextPage');
    },
    indicator(num) {
      return indicator(num).toUpperCase();
    }
  }
};
</script>
